export default __webpack_public_path__ + "static/media/SheetMetalImg6.f352e76e.jpg";